var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('header',[_c('h1',{staticClass:"text-center text-light"},[_vm._v("La Weá Interpreter")])])}]

export { render, staticRenderFns }